/* Cello – página de produto. JS leve, sem dependências.
   Variantes, galeria (swipe/miniaturas/zoom), escalões, quantidade, adicionar ao carrinho (gaveta do Impulse),
   barra fixa no telemóvel, datas de entrega (a partir de window.CelloConfig), diálogos e produtos complementares. */
(function () {
  'use strict';

  /* ---------- Utilitários ---------- */
  function qs(el, s) { return el.querySelector(s); }
  function qsa(el, s) { return Array.prototype.slice.call(el.querySelectorAll(s)); }
  function setText(el, t) { if (el) el.textContent = t; }

  function openDialog(dlg) {
    if (!dlg) return;
    if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
  }
  function closeDialog(dlg) {
    if (!dlg) return;
    if (typeof dlg.close === 'function') dlg.close(); else dlg.removeAttribute('open');
  }
  function initDialogs(root) {
    qsa(root, '[data-open-dialog]').forEach(function (btn) {
      btn.addEventListener('click', function () { openDialog(document.getElementById(btn.getAttribute('data-open-dialog'))); });
    });
    qsa(root, 'dialog').forEach(function (dlg) {
      qsa(dlg, '[data-close-dialog]').forEach(function (b) { b.addEventListener('click', function () { closeDialog(dlg); }); });
      dlg.addEventListener('click', function (e) { if (e.target === dlg) closeDialog(dlg); }); /* clique no fundo */
    });
  }

  /* Adicionar ao carrinho via AJAX e abrir a gaveta do Impulse (evento ajaxProduct:added). */
  function addToCart(formData, btn, errorEl, cartType) {
    if (btn) { btn.setAttribute('aria-busy', 'true'); btn.disabled = true; }
    if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }
    return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: formData
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.data && (res.data.description || res.data.message) || '');
        if (cartType === 'page') { window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart'; return; }
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: res.data, addToCartBtn: btn } }));
      })
      .catch(function (err) {
        if (errorEl) { errorEl.textContent = err.message || errorEl.getAttribute('data-default') || ''; errorEl.hidden = !errorEl.textContent; }
      })
      .finally(function () { if (btn) { btn.removeAttribute('aria-busy'); btn.disabled = btn.hasAttribute('data-unavailable'); } });
  }

  /* ---------- Datas de entrega (dias úteis, sem fins de semana nem feriados) ---------- */
  function addBusinessDays(start, days, holidays) {
    var d = new Date(start.getTime());
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      var iso = d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
      var dow = d.getDay();
      if (dow !== 0 && dow !== 6 && holidays.indexOf(iso) === -1) added++;
    }
    return d;
  }
  function initDeliveryDates(root) {
    var cfg = window.CelloConfig;
    qsa(root, '[data-delivery-dates]').forEach(function (el) {
      if (!cfg || !cfg.totalMaxDays) return;
      var tpl = el.getAttribute('data-template');
      if (!tpl) return;
      var lang = document.documentElement.lang || 'pl';
      var today = new Date();
      var from = addBusinessDays(today, cfg.totalMinDays, cfg.holidays || []);
      var to = addBusinessDays(today, cfg.totalMaxDays, cfg.holidays || []);
      var fmt;
      try { fmt = new Intl.DateTimeFormat(lang, { day: 'numeric', month: 'long' }); } catch (e) { fmt = new Intl.DateTimeFormat('pl', { day: 'numeric', month: 'long' }); }
      var fromTxt = from.getMonth() === to.getMonth() ? String(from.getDate()) : fmt.format(from);
      el.textContent = tpl.replace('__FROM__', fromTxt).replace('__TO__', fmt.format(to));
    });
  }

  /* "Wysyłka do: wtorek, 3 listopada" = hoje + dias úteis de processamento */
  function initShipsBy(root) {
    var cfg = window.CelloConfig;
    qsa(root, '[data-ships-by]').forEach(function (el) {
      if (!cfg || !cfg.processingDays) return;
      var tpl = el.getAttribute('data-template'), out = qs(el, '[data-ships-by-text]');
      if (!tpl || !out) return;
      var lang = document.documentElement.lang || 'pl', d = addBusinessDays(new Date(), cfg.processingDays, cfg.holidays || []), fmt;
      try { fmt = new Intl.DateTimeFormat(lang, { weekday: 'long', day: 'numeric', month: 'long' }); } catch (e) { fmt = new Intl.DateTimeFormat('pl', { weekday: 'long', day: 'numeric', month: 'long' }); }
      out.textContent = tpl.replace('__DATE__', fmt.format(d));
    });
  }

  /* ---------- Galeria ---------- */
  function Gallery(el) {
    this.el = el;
    this.track = qs(el, '[data-gallery-track]');
    this.slides = qsa(el, '.cello-gallery__slide');
    this.thumbs = qsa(el, '[data-thumb]');
    this.index = 0;
    if (!this.track) return;
    var self = this;
    this.thumbs.forEach(function (t) { t.addEventListener('click', function () { self.go(+t.getAttribute('data-thumb')); }); });
    var prev = qs(el, '[data-gallery-prev]'), next = qs(el, '[data-gallery-next]');
    if (prev) prev.addEventListener('click', function () { self.go(self.index - 1); });
    if (next) next.addEventListener('click', function () { self.go(self.index + 1); });
    var ticking = false;
    this.track.addEventListener('scroll', function () {
      if (ticking) return; ticking = true;
      window.requestAnimationFrame(function () {
        var i = self.nearest();
        if (i !== self.index) self.setActive(i);
        ticking = false;
      });
    }, { passive: true });
  }
  /* slide cujo centro está mais perto do centro visível */
  Gallery.prototype.nearest = function () {
    var center = this.track.scrollLeft + this.track.clientWidth / 2, best = 0, dist = Infinity;
    for (var n = 0; n < this.slides.length; n++) {
      var s = this.slides[n], c = s.offsetLeft - this.track.offsetLeft + s.clientWidth / 2, d = Math.abs(c - center);
      if (d < dist) { dist = d; best = n; }
    }
    return best;
  };
  Gallery.prototype.go = function (i) {
    if (!this.slides.length) return;
    i = (i + this.slides.length) % this.slides.length;
    var s = this.slides[i];
    this.track.scrollTo({ left: s.offsetLeft - this.track.offsetLeft - (this.track.clientWidth - s.clientWidth) / 2, behavior: 'smooth' });
    this.setActive(i);
  };
  Gallery.prototype.setActive = function (i) {
    this.index = i;
    this.thumbs.forEach(function (t) {
      var on = +t.getAttribute('data-thumb') === i;
      t.classList.toggle('is-active', on);
      if (on) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
    });
    /* pausa vídeos que saem de vista */
    this.slides.forEach(function (s, n) { var v = s.querySelector('video'); if (v && n !== i && !v.paused) v.pause(); });
  };
  Gallery.prototype.goToMedia = function (mediaId) {
    if (!mediaId) return;
    for (var n = 0; n < this.slides.length; n++) {
      if (this.slides[n].getAttribute('data-media-id') === String(mediaId)) { this.go(n); return; }
    }
  };

  /* ---------- Produto ---------- */
  function Product(root) {
    this.root = root;
    var json = qs(root, '[data-product-json]');
    this.data = json ? JSON.parse(json.textContent) : { variants: [], strings: {} };
    this.form = qs(root, 'form[data-product-form]');
    this.variantInput = qs(root, '[data-variant-input]');
    this.qtyInput = qs(root, '[data-qty-input]');
    this.atc = qs(root, '[data-atc]');
    this.atcLabel = qs(root, '[data-atc-label]');
    this.error = qs(root, '[data-atc-error]');
    this.cartType = root.getAttribute('data-cart-type');
    this.productUrl = root.getAttribute('data-product-url');
    var g = qs(root, '[data-gallery]');
    this.gallery = g ? new Gallery(g) : null;
    if (this.error) this.error.setAttribute('data-default', this.data.strings.error || '');

    this.bindOptions();
    this.bindQuantity();
    this.bindTiers();
    this.bindForm();
    this.bindSticky();
    this.bindZoom();
    initDialogs(root);
    initDeliveryDates(root);
    initShipsBy(root);
    this.currentVariant = this.findVariant();
    this.markAvailability();
    this.syncTiers();
  }

  Product.prototype.selectedOptions = function () {
    return qsa(this.root, '.cello-variants__option').map(function (fs) {
      var c = fs.querySelector('input[data-option-input]:checked');
      return c ? c.value : null;
    });
  };
  Product.prototype.findVariant = function () {
    var sel = this.selectedOptions();
    if (!sel.length) return this.data.variants[0];
    return this.data.variants.find(function (v) {
      return v.options.every(function (o, i) { return o === sel[i]; });
    }) || null;
  };

  Product.prototype.bindOptions = function () {
    var self = this;
    qsa(this.root, 'input[data-option-input]').forEach(function (input) {
      input.addEventListener('change', function () {
        var fs = input.closest('.cello-variants__option');
        setText(fs && fs.querySelector('[data-option-selected]'), input.value);
        self.onVariantChange();
      });
    });
  };

  Product.prototype.onVariantChange = function () {
    var v = this.findVariant();
    this.currentVariant = v;
    var s = this.data.strings;
    var unavailable = !v || !v.available;

    if (v) {
      this.variantInput.value = v.id;
      /* URL ?variant= */
      if (window.history && history.replaceState) {
        history.replaceState({}, '', this.productUrl + '?variant=' + v.id);
      }
      /* preço, preço riscado, selo, Omnibus */
      var price = qs(this.root, '[data-price]');
      setText(price, v.price);
      if (price) price.classList.toggle('is-sale', !!v.compare);
      var cmp = qs(this.root, '[data-compare]');
      if (cmp) { cmp.hidden = !v.compare; setText(qs(cmp, '[data-compare-value]'), v.compare || ''); }
      var badge = qs(this.root, '[data-badge]');
      if (badge) {
        badge.hidden = !v.badge;
        if (v.badge) badge.textContent = badge.textContent.replace(/\d+/, v.badge);
      }
      var om = qs(this.root, '[data-omnibus]');
      if (om) { om.hidden = !v.omnibus; setText(om, v.omnibus || ''); }
      /* galeria */
      if (this.gallery && v.media_id) this.gallery.goToMedia(v.media_id);
      /* escalões */
      qsa(this.root, '[data-tier]').forEach(function (t, i) {
        if (!v.tiers || !v.tiers[i]) return;
        setText(qs(t, '[data-tier-per]'), v.tiers[i].per);
        setText(qs(t, '[data-tier-save]'), v.tiers[i].save);
      });
      /* barra fixa */
      setText(qs(this.root, '[data-sticky-variant]'), v.title);
      setText(qs(this.root, '[data-sticky-price]'), v.price);
    }

    /* botão */
    var label = !v ? s.unavailable : (v.available ? s.addToCart : s.soldOut);
    if (this.atc) {
      this.atc.disabled = unavailable;
      if (unavailable) this.atc.setAttribute('data-unavailable', ''); else this.atc.removeAttribute('data-unavailable');
    }
    setText(this.atcLabel, label);
    var sb = qs(this.root, '[data-sticky-atc]');
    if (sb) { sb.disabled = unavailable; setText(qs(sb, '[data-sticky-label]'), label); }
    this.updateAvailability(v);
    this.markAvailability();
  };

  /* Ponto de disponibilidade: texto real (sem números inventados) */
  Product.prototype.updateAvailability = function (v) {
    var el = qs(this.root, '[data-availability]');
    if (!el) return;
    var s = this.data.strings, txt;
    var lowOn = el.getAttribute('data-low-enabled') === 'true', lim = parseInt(el.getAttribute('data-low-threshold'), 10) || 0;
    if (!v || !v.available) txt = s.soldOut;
    else if (lowOn && v.stock !== null && v.stock > 0 && v.stock <= lim) txt = s.lowStock.replace('__COUNT__', v.stock);
    else txt = s.inStock;
    el.classList.toggle('is-out', !v || !v.available);
    setText(qs(el, '[data-availability-text]'), txt);
  };

  /* Risca valores que, combinados com as outras opções escolhidas, não têm stock. */
  Product.prototype.markAvailability = function () {
    var self = this;
    var sel = this.selectedOptions();
    qsa(this.root, '.cello-variants__option').forEach(function (fs, oi) {
      qsa(fs, 'input[data-option-input]').forEach(function (input) {
        var test = sel.slice(); test[oi] = input.value;
        var ok = self.data.variants.some(function (v) {
          return v.available && v.options.every(function (o, i) { return o === test[i]; });
        });
        var lab = input.nextElementSibling;
        if (lab) lab.classList.toggle('is-unavailable', !ok);
      });
    });
  };

  Product.prototype.bindQuantity = function () {
    var self = this, q = this.qtyInput;
    if (!q) return;
    var minus = qs(this.root, '[data-qty-minus]'), plus = qs(this.root, '[data-qty-plus]');
    function set(n) { q.value = Math.max(1, Math.min(99, n || 1)); self.syncTiers(); }
    if (minus) minus.addEventListener('click', function () { set(+q.value - 1); });
    if (plus) plus.addEventListener('click', function () { set(+q.value + 1); });
    q.addEventListener('change', function () { set(parseInt(q.value, 10)); });
  };

  Product.prototype.bindTiers = function () {
    var self = this;
    qsa(this.root, '[data-tier]').forEach(function (t) {
      t.addEventListener('click', function () {
        var n = parseInt(t.getAttribute('data-tier-qty'), 10) || 1;
        if (self.qtyInput) self.qtyInput.value = n;
        self.syncTiers(n);
      });
    });
  };
  /* Realça o escalão ativo conforme a quantidade escolhida. */
  Product.prototype.syncTiers = function (forced) {
    var qty = forced || (this.qtyInput ? parseInt(this.qtyInput.value, 10) : 1) || 1;
    var tiers = qsa(this.root, '[data-tier]');
    var active = -1;
    tiers.forEach(function (t, i) { if (qty >= (parseInt(t.getAttribute('data-tier-qty'), 10) || 0)) active = i; });
    tiers.forEach(function (t, i) {
      t.classList.toggle('is-active', i === active);
      if (t.tagName === 'BUTTON') t.setAttribute('aria-pressed', i === active ? 'true' : 'false');
    });
  };

  Product.prototype.bindForm = function () {
    var self = this;
    if (!this.form) return;
    this.form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!self.currentVariant || !self.currentVariant.available) return;
      addToCart(new FormData(self.form), self.atc, self.error, self.cartType);
    });
  };

  Product.prototype.bindSticky = function () {
    var bar = qs(this.root, '[data-cello-sticky]');
    if (!bar || !this.atc || !('IntersectionObserver' in window)) return;
    var self = this;
    bar.hidden = false;
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      /* visível só depois de o botão principal passar para cima do ecrã */
      var show = !e.isIntersecting && e.boundingClientRect.top < 0;
      bar.classList.toggle('is-visible', show);
      document.body.classList.toggle('cello-has-sticky', show);
    }).observe(this.atc);
    var btn = qs(bar, '[data-sticky-atc]');
    if (btn) btn.addEventListener('click', function () {
      if (self.form.requestSubmit) self.form.requestSubmit(); else self.atc.click();
    });
  };

  Product.prototype.bindZoom = function () {
    var dlg = qs(this.root, '[data-zoom-dialog]');
    if (!dlg) return;
    var img = qs(dlg, '[data-zoom-img]');
    qsa(this.root, '[data-zoom]').forEach(function (b) {
      b.addEventListener('click', function () {
        img.src = b.getAttribute('data-zoom-src');
        img.alt = b.getAttribute('data-zoom-alt') || '';
        openDialog(dlg);
      });
    });
  };

  /* ---------- Produtos complementares (adicionar rápido) ---------- */
  function initQuickAdd(root) {
    qsa(root, 'form[data-quick-add]').forEach(function (form) {
      if (form.__cello) return; form.__cello = true;
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        addToCart(new FormData(form), qs(form, 'button[type="submit"]'), qs(form, '[data-quick-error]'), root.getAttribute('data-cart-type'));
      });
    });
  }
  function initComplementary(section) {
    var url = section.getAttribute('data-url');
    if (!url) { initQuickAdd(section); return; }
    var target = qs(section, '[data-cards]');
    function load(u) { return fetch(u).then(function (r) { return r.text(); }); }
    function apply(html) {
      var tmp = document.createElement('div'); tmp.innerHTML = html;
      var cards = qs(tmp, '[data-cards]');
      if (cards && cards.children.length) { target.innerHTML = cards.innerHTML; section.hidden = false; initQuickAdd(section); return true; }
      return false;
    }
    var io = new IntersectionObserver(function (entries, obs) {
      if (!entries[0].isIntersecting) return;
      obs.disconnect();
      load(url + '&intent=complementary').then(function (h) {
        if (!apply(h)) return load(url + '&intent=related').then(apply);
      }).catch(function () {});
    }, { rootMargin: '400px 0px' });
    io.observe(section);
  }

  /* ---------- Arranque ---------- */
  function init() {
    qsa(document, '[data-cello-product]').forEach(function (el) { if (!el.__cello) { el.__cello = true; new Product(el); } });
    qsa(document, '[data-cello-complementary]').forEach(function (el) { if (!el.__cello) { el.__cello = true; initComplementary(el); } });
    qsa(document, '[data-cello-dialogs]').forEach(function (el) { if (!el.__cello) { el.__cello = true; initDialogs(el); } });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  /* editor de temas */
  document.addEventListener('shopify:section:load', init);
})();
